"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpgradeCompletionDialog = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _ = require("../../");

var _sadTraceBot = _interopRequireDefault(require("../../assets/img/sad-trace-bot.png"));

require("./UpgradeCompletionDialog.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vars
var familyBullets = ['You have access to your past video', 'Your equipment will ship out within 30 days', 'Look for a welcome email with instructions for setting up your account', 'You can find setup instructions in our getting started guide'];
var teamBullets = ['You have access to your past video', 'Your equipment will ship out within 14 days', 'Look for a welcome email from your dedicated Customer Success Manager with instructions for setting up your team(s)']; // Success Content

var SuccessContent = function SuccessContent(_ref) {
  var upgradedTo = _ref.upgradedTo,
      location = _ref.location,
      profile = _ref.profile,
      confirmedUpgrade = _ref.confirmedUpgrade,
      upgradeFailed = _ref.upgradeFailed;
  var initials = profile ? (0, _.getAcronymFromString)(profile.name) : "";
  return /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "SuccessBanner"
  }, upgradedTo === 'traceId' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Element, {
    className: "imagesContainer"
  }, /*#__PURE__*/_react.default.createElement(_.Avatar, {
    size: 80,
    imageUrl: profile === null || profile === void 0 ? void 0 : profile.image_url,
    initials: initials
  }), /*#__PURE__*/_react.default.createElement(_.Badge, {
    className: "badge",
    color: _.Color.Sky,
    padding: "0 2",
    position: _.Badge.Position.BottomRight,
    size: 24,
    width: 42
  }, "Plus")), !confirmedUpgrade && !upgradeFailed && /*#__PURE__*/_react.default.createElement(_.Loading, {
    mT: "var(--spacing-2x)"
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    color: _.Color.Black,
    type: _.Label.Type.Body,
    marginTop: "3",
    content: /*#__PURE__*/_react.default.createElement(_.Label, {
      center: true,
      content: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_.Label, {
        bold: true,
        className: "label-success",
        content: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, "'s ")
      }), !confirmedUpgrade && !upgradeFailed && /*#__PURE__*/_react.default.createElement(_.Label, {
        spacingLeft: "1",
        className: "label-success",
        content: "account is being upgraded to Trace iD+"
      }), confirmedUpgrade && !upgradeFailed && /*#__PURE__*/_react.default.createElement(_.Label, {
        spacingLeft: "1",
        className: "label-success",
        content: "account has been upgraded to Trace iD+"
      }), upgradeFailed && /*#__PURE__*/_react.default.createElement(_.Label, {
        spacingLeft: "1",
        className: "label-success",
        content: "account failed to upgrade. Please try again"
      }))
    })
  })), upgradedTo === 'family' && /*#__PURE__*/_react.default.createElement(_.Column, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    marginBottom: "4",
    bold: true
  }, "Next steps:"), /*#__PURE__*/_react.default.createElement(_.Element, {
    tag: "ul",
    className: "list-bullets"
  }, familyBullets.map(function (bullet, index) {
    return /*#__PURE__*/_react.default.createElement(_.Element, {
      tag: "li",
      key: "renew-plan-card-li-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      color: _.Color.Grey1,
      className: "bullet",
      type: _.Label.Type.Body
    }, bullet));
  }))), upgradedTo === 'team' && /*#__PURE__*/_react.default.createElement(_.Column, null, /*#__PURE__*/_react.default.createElement(_.Label, {
    marginBottom: "4",
    bold: true
  }, "Next steps:"), /*#__PURE__*/_react.default.createElement(_.Element, {
    tag: "ul",
    className: "list-bullets"
  }, teamBullets.map(function (bullet, index) {
    return /*#__PURE__*/_react.default.createElement(_.Element, {
      tag: "li",
      key: "renew-plan-card-li-".concat(index)
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      color: _.Color.Grey1,
      className: "bullet",
      type: _.Label.Type.Body
    }, bullet));
  }))));
};

var CancelContent = function CancelContent() {
  return /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "CancelBanner"
  }, /*#__PURE__*/_react.default.createElement(_.Element, {
    tag: "img",
    className: "tracebot",
    src: _sadTraceBot.default,
    alt: "Sad Trace Bot"
  }), /*#__PURE__*/_react.default.createElement(_.Column, {
    padding: "6 8"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    bold: true
  }, "You cancelled the subscription"), /*#__PURE__*/_react.default.createElement(_.Label, {
    marignTop: 4,
    center: true,
    color: _.Color.Grey2
  }, "Get access to Trace iD+ content anytime by subscribing later")));
}; // Upgrade Completion Dialog


var UpgradeCompletionDialog = function UpgradeCompletionDialog(_ref2) {
  var profile = _ref2.profile,
      success = _ref2.success,
      showButton = _ref2.showButton,
      onClose = _ref2.onClose,
      onAction = _ref2.onAction,
      buttonTitle = _ref2.buttonTitle,
      upgradedTo = _ref2.upgradedTo,
      hideCloseButton = _ref2.hideCloseButton,
      showConfirmationText = _ref2.showConfirmationText,
      confirmedUpgrade = _ref2.confirmedUpgrade,
      upgradeFailed = _ref2.upgradeFailed;
  var location = (0, _reactRouter.useLocation)(); // Labels

  var handleCloseButtonClick = function handleCloseButtonClick(e) {
    e.preventDefault();

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  var handleActionButtonClick = function handleActionButtonClick(e) {
    e.preventDefault();

    if (typeof onAction === 'function') {
      onAction(upgradedTo, profile);
    }
  };

  var getDialogTitle = function getDialogTitle() {
    var title;

    switch (upgradedTo) {
      case 'traceId':
        {
          title = success ? 'Welcome to Trace iD+' : 'Not upgraded';
          break;
        }

      case 'family':
      case 'team':
        {
          title = 'Welcome back!';
          break;
        }
    }

    return title;
  };

  var title = getDialogTitle();
  return /*#__PURE__*/_react.default.createElement(_.Modal, {
    className: "UpgradeCompletionDialog",
    open: true,
    onShadeClick: function onShadeClick(e) {
      handleCloseButtonClick(e);
    }
  }, /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    className: "header",
    onCloseClick: handleCloseButtonClick,
    hideCloseButton: hideCloseButton
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    type: _.Label.Type.Heading4,
    content: title
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, null, success && /*#__PURE__*/_react.default.createElement(SuccessContent, {
    upgradedTo: upgradedTo,
    location: location,
    profile: profile,
    confirmedUpgrade: confirmedUpgrade,
    upgradeFailed: upgradeFailed
  }), !success && /*#__PURE__*/_react.default.createElement(CancelContent, {
    location: location
  })), success && showButton && /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Button, {
    className: "upgrade-button",
    primary: true,
    content: buttonTitle,
    onClick: function onClick(e) {
      handleActionButtonClick(e);
    }
  })), showConfirmationText && /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Row, {
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "8"
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: _.Icon.Type.Check,
    color: _.Color.TraceTint1,
    marginRight: "2"
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    color: _.Color.Trace,
    type: _.Label.Type.Body,
    bold: true,
    content: "We'll be in touch to setup your account."
  }))));
};

exports.UpgradeCompletionDialog = UpgradeCompletionDialog;
UpgradeCompletionDialog.defaultProps = {
  buttonTitle: 'Upgrade additional family members',
  showConfirmationText: false,
  confirmedUpgrade: false,
  upgradedTo: "traceId"
};